// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/radio-nav-aids.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/radio-nav-aids/radio-nav-aids.js';

mount([g0]);
